import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Injectable()
export class PostRequestsService {

  private _renderer: Renderer2;

  constructor(
    _rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private _document: any
  ) {
    this._renderer = _rendererFactory.createRenderer(null, null);
  }

  post_request(postUrl: string, data: any, target = null): void {

    if ((postUrl === undefined || postUrl === null) || (data === null || data === undefined)) {
      console.error('Post requests parameters are null or undefined.');
      return;
    }

    this._submitForm(postUrl, data, target);
  }

  private _submitForm(postUrl: string, data: any, target = null): void {
    let form: HTMLFormElement;
    form = this._renderer.createElement('form');
    form.method = 'post';
    form.action = postUrl;

    if (data.form) {
        const formSettings = Object.keys(data.form);
        formSettings.forEach(setting => {
            form[setting] = data.form[setting];
        });
    }

    for ( const key in data ) {
      if (data[key]) {
        let input: HTMLInputElement;
        input = this._renderer.createElement('input');
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      }
    }
    // form submit trigger
    let submitButton: HTMLButtonElement;
    submitButton = this._renderer.createElement('button');
    submitButton.type = 'submit';
    submitButton.textContent = 'submit';
    form.appendChild(submitButton);

    if (target !== null ) {
      form = Object.assign(form, {target});
    }

    form.style.display = 'none';
    this._document.body.appendChild(form);

    submitButton.click();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/post-requests.service.ts